import { KnockErrorBoundary } from "@src/appV2/Knock/components/KnockErrorBoundary";

import { useEmitReviewPromptAttributes } from "./useEmitReviewPromptAttributes";

function ReviewPromptAttributesEmitterInner(): null {
  useEmitReviewPromptAttributes();
  return null;
}

/**
 * Headless mount point for the rating-prompt user-attribute emitter. Sibling
 * of `ReviewPromptGuide` inside `KnockGuidesConsumers` — the parent already
 * gates on a live `knockToken`, so the authenticated Knock client resolved
 * by the hook is guaranteed.
 */
export function ReviewPromptAttributesEmitter(): JSX.Element {
  return (
    <KnockErrorBoundary>
      <ReviewPromptAttributesEmitterInner />
    </KnockErrorBoundary>
  );
}
